<script>
  import { onMount } from "svelte";

  export let emptyLeg;
  export let status;
  let dateTimeFormatted = "";

  onMount(() => {
    dateTimeFormatted = emptyLeg.datetimelocal.toFormat("ccc, LLL d, y; HH:mm a");
  });
</script>

<style>
  .leg {
    font-size: 10pt;
    padding: 4px;
  }
  .leg .when {
    color: #000;
  }
  .leg .when .gmt {
    font-size: 0.8em;
  }
  .leg .when .status {
    background: #aaa;
    color: #fff;
    padding: 2px 4px;
    margin-left: 5px;
    font-size: 0.7em;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .leg img {
    vertical-align: text-bottom;
  }
  .leg .airport img {
    margin-right: 5px;
  }
  .leg .airport .name {
    font-size: 0.8em;
  }
</style>

<div class="leg">

  <div class="when">
    {dateTimeFormatted}
    <span class="gmt">GMT{emptyLeg.gmtoffset}</span>
    <span class="status">{status}</span>
  </div>

  <div class="airport">
    <img src="assets/airport-departure.svg" alt="" />
    {emptyLeg.fromairport.gps_code}
    <span class="name">{emptyLeg.fromairport.name}</span>
  </div>

  <div class="airport">
    <img src="assets/airport-arrival.svg" alt="" />
    {emptyLeg.toairport.gps_code}
    <span class="name">{emptyLeg.toairport.name}</span>
  </div>
</div>
